import React, {useState} from 'react';
import Sidebar, {SidebarItem} from './Sidebar';
import {useLocation} from 'react-router-dom';

type Props = {
  titleKey: string;
  menuItems: SidebarItem[];
  children: React.ReactNode;
  isSystem?: boolean;
};

const DashboardLayout: React.FC<Props> = ({titleKey, menuItems, children, isSystem}) => {

  const [sidebarWidth, setSidebarWidth] = useState(0)
  const location = useLocation();

  const rightSidebar = menuItems.some(
      item => item.rightSideBar && location.pathname.startsWith(item.to)
  );

  return (
      <div className="flex min-h-screen lg:min-h-[87vh] bg-light dark:bg-dark text-light-text dark:text-dark-text">
        <Sidebar titleKey={titleKey} items={menuItems} setSidebarWidth={setSidebarWidth} isSystem={isSystem}/>
        <main
            className={`flex-1 ${rightSidebar ? '' : 'px-2 mt-2 py-2 lg:px-3 lg:pt-6 lg:pb-4'}`}
            style={{width: `calc(100% - ${sidebarWidth}px)`}}
        >
          {children}
        </main>
      </div>
  );
};

export default DashboardLayout;